import { PAYMENT_STATUS } from '../constants'

const STATUS_COLOR = {
  [PAYMENT_STATUS.UNKNOWN]: 'grey',
  [PAYMENT_STATUS.OPEN]: 'blue',
  [PAYMENT_STATUS.PROCESSING]: 'orange',
  [PAYMENT_STATUS.SUCCESS]: 'green',
  [PAYMENT_STATUS.CANCELLED]: 'red',
  [PAYMENT_STATUS.FAILED]: 'red',
}

export const getTextColorByStatus = (status) => {
  return STATUS_COLOR[status] || 'black'
}

const STATUS_TEXT = {
  [PAYMENT_STATUS.UNKNOWN]: 'ทั้งหมด',
  [PAYMENT_STATUS.OPEN]: 'จองสำเร็จ',
  [PAYMENT_STATUS.PROCESSING]: 'กำลังประมวลผล',
  [PAYMENT_STATUS.SUCCESS]: 'สำเร็จ',
  [PAYMENT_STATUS.CANCELLED]: 'ถูกยกเลิก',
  [PAYMENT_STATUS.FAILED]: 'ไม่สำเร็จ',
}

export const getButtonTextByStatus = (status) => {
  return STATUS_TEXT[status] || status
}

const STATUS_BACKGROUND_COLOR = {
  [PAYMENT_STATUS.UNKNOWN]: 'lightgrey',
  [PAYMENT_STATUS.OPEN]: 'lightblue',
  [PAYMENT_STATUS.PROCESSING]: 'rgba(255,160,50,0.35)',
  [PAYMENT_STATUS.SUCCESS]: 'rgba(0,128,0,0.35)',
  [PAYMENT_STATUS.CANCELLED]: 'rgb(255,192,203,0.75)',
  [PAYMENT_STATUS.FAILED]: 'rgb(255,192,203,0.75)',
}

export const getBackgroundColorByStatus = (status) => {
  return STATUS_BACKGROUND_COLOR[status] || 'white'
}

export const NUMBER_LOTTERY = {
  ALL: 'ALL',
  FIRST_THREE: 'FIRST_THREE',
  LAST_THREE: 'LAST_THREE',
  LAST_TWO: 'LAST_TWO',
}

export const NUMBER_LOTTERY_MAX_LENGTH = {
  [NUMBER_LOTTERY.ALL]: 6,
  [NUMBER_LOTTERY.FIRST_THREE]: 3,
  [NUMBER_LOTTERY.LAST_THREE]: 3,
  [NUMBER_LOTTERY.LAST_TWO]: 2,
}

export const getNumberLotteryMaxLength = (number) => {
  return NUMBER_LOTTERY_MAX_LENGTH[number] || 6
}

const NUMBER_LOTTERY_TEXT = {
  [NUMBER_LOTTERY.ALL]: 'ทั้งหมด',
  [NUMBER_LOTTERY.FIRST_THREE]: 'เลขหน้า 3 ตัว',
  [NUMBER_LOTTERY.LAST_THREE]: 'เลขท้าย 3 ตัว',
  [NUMBER_LOTTERY.LAST_TWO]: 'เลขท้าย 2 ตัว',
}

export const getButtonTextByNumberLottery = (number) => {
  return NUMBER_LOTTERY_TEXT[number] || number
}

export const formatNumberLottery = (typeNumber, value) => {
  switch (typeNumber) {
    case 'FIRST_THREE':
      return value.padEnd(6, '.')

    case 'LAST_THREE':
      return '...' + value
    case 'LAST_TWO':
      return '....' + value

    default:
      return value
  }
}
